import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import Button from '@wix/da-shared-react/pkg/Button';
import s from './MoreDeviationsBySearch.scss';

export interface Props {
  searchTerm: string;
  mainContentUrl?: string;
}

export const MoreDeviationsBySearch: React.FC<Props> = ({
  searchTerm,
  mainContentUrl,
}) => {
  const { t } = useTranslation();
  return (
    <div className={s['root']}>
      {/* prettier-ignore */}
      <div className={s['top-row']}>
        <Trans i18nKey="facetPage.strip.moreDeviationsBySearch" parent="span">
          More{' '}
          <span className={s['search-term']}>
            {{ searchTerm }}
          </span>{' '}
          Deviations
        </Trans>
      </div>
      {mainContentUrl && (
        <Button
          view="b33"
          href={mainContentUrl}
          className={s['view-all']}
          biData={{
            evid: BiEventType.SEE_ALL_CLICK,
          }}
        >
          {t('facetPage.strip.all')}
        </Button>
      )}
    </div>
  );
};
MoreDeviationsBySearch.displayName = 'MoreDeviationsBySearch';

export default MoreDeviationsBySearch;
